import { arredondar2, dataISOLocal } from '../pedidos/precos'
import type { RegraComissao } from '../db/tipos'

export function dentroDoPeriodo(data: string, inicio: string, fim: string): boolean {
  return data >= inicio && data <= fim
}

export function somaNoPeriodo(
  valores: Array<{ valor: number; data: string }>,
  inicio: string,
  fim: string,
): number {
  const total = valores
    .filter((v) => dentroDoPeriodo(v.data, inicio, fim))
    .reduce((soma, v) => soma + v.valor, 0)
  return arredondar2(total)
}

function diasEntre(inicio: string, fim: string): number {
  const [aI, mI, dI] = inicio.split('-').map(Number)
  const [aF, mF, dF] = fim.split('-').map(Number)
  const ms = new Date(aF, mF - 1, dF).getTime() - new Date(aI, mI - 1, dI).getTime()
  return Math.round(ms / 86_400_000) + 1 // inclusivo
}

export function calcularRitmo(
  realizado: number,
  hoje: Date,
  inicio: string,
  fim: string,
): { projecao: number; pctDecorrido: number } {
  const hojeISO = dataISOLocal(hoje)
  const totalDias = diasEntre(inicio, fim)
  const decorridos = Math.min(totalDias, Math.max(1, diasEntre(inicio, hojeISO > fim ? fim : hojeISO)))
  const pctDecorrido = (decorridos / totalDias) * 100
  const projecao =
    hojeISO > fim ? realizado : arredondar2((realizado / decorridos) * totalDias)
  return { projecao, pctDecorrido }
}

export function faltamVenderPorRepresentada(
  faltaComissao: number,
  regras: RegraComissao[],
): Array<{ representada_id: string; pct: number; vendasNecessarias: number }> {
  return regras
    .filter((r) => r.apagado_em === null && r.pct_padrao !== null && r.pct_padrao > 0)
    .map((r) => ({
      representada_id: r.representada_id,
      pct: r.pct_padrao!,
      vendasNecessarias: arredondar2((faltaComissao / r.pct_padrao!) * 100),
    }))
}
